import { composeIO } from 'react-compose-io'
import { regularizacaoCiclosResumoIO } from './RegularizacaoCiclosResumo.IO'
import { RegularizacaoCiclosResumoView } from './RegularizacaoCiclosResumo.View'

export const RegularizacaoCiclosResumo = composeIO(RegularizacaoCiclosResumoView, regularizacaoCiclosResumoIO)
